export default __webpack_public_path__ + "static/media/noData.26fc5b71.svg";